import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ef234d94"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "route-selector-modal__header" };
const _hoisted_2 = { class: "route-selector-modal__subtitle" };
const _hoisted_3 = { class: "route-selector-modal__content" };
const _hoisted_4 = { class: "route-selector-modal__search" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-search-12px route-selector-modal__search-icon" }, null, -1));
const _hoisted_6 = ["placeholder", "onKeydown"];
const _hoisted_7 = { class: "route-selector-modal__list" };
const _hoisted_8 = {
    key: 0,
    class: "route-selector-modal__empty"
};
const _hoisted_9 = ["onClick", "onMouseenter"];
const _hoisted_10 = { class: "route-selector-modal__item-content" };
const _hoisted_11 = { class: "route-selector-modal__item-main" };
const _hoisted_12 = { class: "route-selector-modal__item-name" };
const _hoisted_13 = {
    key: 0,
    class: "icon icon-checked-12px route-selector-modal__item-check"
};
const _hoisted_14 = {
    key: 0,
    class: "route-selector-modal__item-category"
};
const _hoisted_15 = { class: "route-selector-modal__hint" };
const _hoisted_16 = { class: "route-selector-modal__hint-item" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("kbd", null, "↑", -1));
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("kbd", null, "↓", -1));
const _hoisted_19 = { class: "route-selector-modal__hint-item" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("kbd", null, "Enter", -1));
const _hoisted_21 = { class: "route-selector-modal__hint-item" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("kbd", null, "Esc", -1));
import bus from '@/helpers/events/bus';
import { menuItems } from '@/helpers/menu';
import { stringParser } from '@/helpers/string-parser';
import i18n from '@/i18n';
import { routesWithoutChildren } from '@/utilities/constants/constants';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RouteSelectorModal',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        const isVisible = ref(false);
        const searchQuery = ref('');
        const searchInput = ref(null);
        const highlightedIndex = ref(0);
        const routeRefs = ref([]);
        const brandRoutes = computed(() => store.getters.getRoutes || []);
        // Build a flat list of available routes with categories
        const availableRoutes = computed(() => {
            if (!brandRoutes.value.length)
                return [];
            const routes = [];
            brandRoutes.value.forEach((brandRoute) => {
                // Find category in menuItems
                const category = menuItems.find((item) => item.id === brandRoute.id);
                if (!category)
                    return;
                // Routes without children (standalone routes)
                if (routesWithoutChildren.includes(brandRoute.id) || !brandRoute.routes) {
                    routes.push({
                        id: category.id,
                        name: category.name,
                        url: category.url,
                        category: null,
                        categoryName: null,
                    });
                    return;
                }
                // Routes with subcategories
                if (brandRoute.routes && brandRoute.routes.length > 0) {
                    brandRoute.routes.forEach((subRoute) => {
                        const subRouteItem = menuItems.find((item) => item.id === subRoute.id);
                        if (subRouteItem) {
                            routes.push({
                                id: subRouteItem.id,
                                name: subRouteItem.name,
                                url: subRouteItem.url,
                                category: brandRoute.id,
                                categoryName: category.name,
                            });
                        }
                    });
                }
            });
            return routes;
        });
        const filteredRoutes = computed(() => {
            if (!searchQuery.value.trim()) {
                return availableRoutes.value;
            }
            const query = stringParser(searchQuery.value);
            return availableRoutes.value.filter((routeItem) => {
                const translatedRouteName = i18n.global.t(routeItem.name);
                const translatedCategoryName = routeItem.categoryName ? i18n.global.t(routeItem.categoryName) : '';
                const routeName = stringParser(translatedRouteName);
                const categoryName = stringParser(translatedCategoryName);
                return routeName.includes(query) || categoryName.includes(query);
            });
        });
        function isCurrentRoute(routeItem) {
            return route.name === routeItem.id;
        }
        function setRouteRef(el, index) {
            if (el && el instanceof HTMLElement) {
                routeRefs.value[index] = el;
            }
        }
        function scrollToHighlighted() {
            nextTick(() => {
                const highlightedEl = routeRefs.value[highlightedIndex.value];
                if (highlightedEl) {
                    highlightedEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            });
        }
        function navigateDown() {
            if (highlightedIndex.value < filteredRoutes.value.length - 1) {
                highlightedIndex.value++;
                scrollToHighlighted();
            }
        }
        function navigateUp() {
            if (highlightedIndex.value > 0) {
                highlightedIndex.value--;
                scrollToHighlighted();
            }
        }
        function selectHighlightedRoute() {
            const route = filteredRoutes.value[highlightedIndex.value];
            if (route) {
                navigateToRoute(route);
            }
        }
        function navigateToRoute(routeItem) {
            if (isCurrentRoute(routeItem)) {
                closeModal();
                return;
            }
            useMixpanelConfig('route-selector_clicked', {
                searchQuery: searchQuery.value,
                selectedRoute: routeItem.id,
            });
            router.push(routeItem.url);
            closeModal();
        }
        function openModal() {
            isVisible.value = true;
            searchQuery.value = '';
            highlightedIndex.value = 0;
            useMixpanelConfig('route-selector_viewed');
            // setTimeout to wait for Element Plus animations
            const TIMEOUT = 100;
            setTimeout(() => {
                if (searchInput.value) {
                    searchInput.value.focus();
                }
            }, TIMEOUT);
        }
        function closeModal() {
            isVisible.value = false;
            searchQuery.value = '';
            highlightedIndex.value = 0;
            routeRefs.value = [];
        }
        function handleClosed() {
            searchQuery.value = '';
            highlightedIndex.value = 0;
            routeRefs.value = [];
        }
        watch(searchQuery, () => {
            highlightedIndex.value = 0;
            routeRefs.value = [];
        });
        onMounted(() => {
            bus.$on('open-route-selector-modal', openModal);
        });
        onUnmounted(() => {
            bus.$off('open-route-selector-modal', openModal);
        });
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                id: "route-selector-modal",
                modelValue: isVisible.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((isVisible).value = $event)),
                "show-close": true,
                "append-to-body": "",
                onClosed: handleClosed
            }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('route-selector.title')), 1),
                        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('route-selector.subtitle')), 1)
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _hoisted_5,
                            _withDirectives(_createElementVNode("input", {
                                ref_key: "searchInput",
                                ref: searchInput,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                                placeholder: _ctx.$t('route-selector.search-placeholder'),
                                autofocus: "",
                                class: "route-selector-modal__search-input",
                                type: "text",
                                onKeydown: [
                                    _withKeys(_withModifiers(navigateDown, ["prevent"]), ["down"]),
                                    _withKeys(_withModifiers(navigateUp, ["prevent"]), ["up"]),
                                    _withKeys(_withModifiers(selectHighlightedRoute, ["prevent"]), ["enter"])
                                ]
                            }, null, 40, _hoisted_6), [
                                [_vModelText, searchQuery.value]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            (filteredRoutes.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('_no-results', 2)), 1))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filteredRoutes.value, (route, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: route.id,
                                        ref_for: true,
                                        ref: el => setRouteRef(el, index),
                                        class: _normalizeClass([
                                            'route-selector-modal__item',
                                            { 'route-selector-modal__item--highlighted': index === highlightedIndex.value },
                                            { 'route-selector-modal__item--active': isCurrentRoute(route) },
                                        ]),
                                        onClick: ($event) => (navigateToRoute(route)),
                                        onMouseenter: ($event) => (highlightedIndex.value = index)
                                    }, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(route.name)), 1),
                                                (isCurrentRoute(route))
                                                    ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            (route.category)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t(route.categoryName)), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 42, _hoisted_9));
                                }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _hoisted_17,
                                _hoisted_18,
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('route-selector.navigate')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                                _hoisted_20,
                                _createElementVNode("span", null, _toDisplayString(_ctx.$tc('_select', 2)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _createElementVNode("span", null, _toDisplayString(_ctx.$tc('_close', 2)), 1)
                            ])
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
